import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatTooltipModule } from '@angular/material/tooltip'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { DiscountCodeModule } from './store/discount-code/discount-code.module'
import { MatSelectModule } from '@angular/material/select'
import { ClipboardModule } from 'ngx-clipboard'
import { DiscountCodeDetailComponent } from './components/details/discount-code-detail.component'
import { PermissionModule } from '@tokeet-frontend/permission'

const components = [DiscountCodeDetailComponent]
const dialogs = []

const services = []

const modules = [
  ReactiveFormsModule,
  MatInputModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatTooltipModule,
  MatSelectModule,
  MatDatepickerModule,
  Tv3PlatformModule,
  DiscountCodeModule,
  ClipboardModule,
  PermissionModule,
]

@NgModule({
  imports: [CommonModule, ...modules],
  providers: [...services],
  declarations: [...dialogs, ...components],
  entryComponents: [...dialogs],
  exports: [...modules, ...components],
})
export class DiscountCodeLibModule {}
